// extracted by mini-css-extract-plugin
export default {"btn":"NavBtn_btn__OeWnr"};